import { Outlet } from "react-router-dom";

export default function AdminConsultLayout() {
  return (
    <>
      <Outlet />
    </>
  );
};

